var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { Card, Text } from '@philips-internal/oswald-ui-components/lib/components';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { ReactComponent as CancelSVG } from '../../assets/images/global/cancel.svg';
import { ReactComponent as CheckSVG } from '../../assets/images/global/check.svg';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import './terms-card.css';
import { ModelService } from '@philips-internal/oswald-ui-core/lib/services';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
let TermsCard = class TermsCard extends Component {
    constructor() {
        super(...arguments);
        this.onClick = () => {
            const { onClick } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        onClick
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        onClick: eventListener
    }; }
    getStatusIcon() {
        const { ieSituacao } = this.props;
        if (ieSituacao?.toUpperCase() === 'A') {
            return React.createElement(CheckSVG, { className: 'c-terms-card__status-color-green' });
        }
        if (ieSituacao?.toUpperCase() === 'I') {
            return React.createElement(CheckSVG, { className: 'c-terms-card__status-color-gray' });
        }
        return React.createElement(CancelSVG, { className: 'c-terms-card__status-color-gray' });
    }
    renderDate() {
        const { dtConfirmacao } = this.props;
        return (React.createElement(Text, { className: 'c-terms-card__date' }, ModelService.format('date', dtConfirmacao)));
    }
    renderDescription() {
        const { nmTermo } = this.props;
        return (React.createElement(Text, { className: 'c-terms-card__description' }, nmTermo));
    }
    renderData() {
        return (React.createElement("div", { className: "c-terms-card-content-data" },
            this.renderDescription(),
            this.renderDate()));
    }
    renderStatus() {
        return (React.createElement("div", { className: 'c-terms-card__status' }, this.getStatusIcon()));
    }
    render() {
        const { nrSequencia } = this.props;
        return (React.createElement(Card, { onClick: () => this.onClick(), className: 'c-terms-card', selectionType: SelectionType.SINGLE, uuid: generateUUID(), key: nrSequencia, width: 12 },
            React.createElement("div", { className: 'c-terms-card__wrapper' },
                React.createElement("div", { className: 'c-terms-card__content' },
                    this.renderData(),
                    this.renderStatus()))));
    }
};
TermsCard = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY })
], TermsCard);
export default TermsCard;
//# sourceMappingURL=terms-card.js.map